// extracted by mini-css-extract-plugin
export var cardWrapper = "_94-0";